import { mybets } from "../../js/api/myBets.js";
import { mybet } from "../../js/api/myBet.js";
import { generateView } from "../templates/mybets.js";
import Utils from "../../services/Utils.js";
import { getBetsByUser, getagentsByUser, getBetsByUserFilter } from "../../js/api/getAgents.js";
import { _t } from "../../services/TranslationService.js";
import Timeline from "../components/Timeline.js";
import { userhierarchyforall } from "../../js/api/users.js";

let agentId = 0;
let today = new Date();
let dd = String(today.getDate()).padStart(2, "0");
let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
let yyyy = today.getFullYear();

let months = [
  "Janar",
  "Shkurt",
  "Mars",
  "Prill",
  "Maj",
  "Qershor",
  "Korrik",
  "Gusht",
  "Shtator",
  "Tetor",
  "Nentor",
  "Dhjetor"
];
let currentMonthDescription = `${months[today.getMonth()]}`;

let ranges = {};
ranges[_t('Sot')] = [moment(), moment()];
ranges[_t('Dje')] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
ranges = {
  ...ranges,
  2023: [moment().startOf('year'), moment().endOf('year')],
  2022: [moment().subtract(1, "year").startOf('year'), moment().subtract(1, 'year').endOf('year')],
};

ranges[`${currentMonthDescription}`] = [moment().startOf('month'), moment().endOf('month')];
ranges[`${months[today.getMonth() == 0 ? 11 : today.getMonth() - 1]}`] = [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')];


today = yyyy + "-" + mm + "-" + dd;
let startDate = localStorage.getItem("betsStartDate") || today;
let endDate = localStorage.getItem("betsEndDate") || today;

let MyBetsUserDetails = {
  selectedUser: null,
  render: async () => {
    const request = Utils.parseRequestURL();
    agentId = request.id;
    let userCoins = [];
    let userCoinsView = ``;

    if (localStorage.getItem('coins')) {
        userCoins = JSON.parse(localStorage.getItem('coins'));

        userCoins.forEach(coin => {
          userCoinsView += `<option value="${coin.id}" ${coin.id == localStorage.getItem('currencySelected') ? 'selected' : ''}>${Utils.currencyCode(coin.currency)}</option>`;
        });
    }

    let agentsView = '';
    const users = await userhierarchyforall(agentId);
    if (users && users.data && users.data.children_users.length) {
      const users_unique = [];
      for (let user of users.data.children_users.filter(u => u.state === '1')) {
        if (!users_unique.some(u => u.username === user.username)) {
          users_unique.push(user);
          agentsView = agentsView + `<option value="${user.username}">${user.username}</option>`;
        }
      }
    }

    let role = localStorage.getItem("role");

    let view = /*html*/ `<div class="myBetsWrapper">
             <div class="myBetsHeader">
               <a class="backBtn">
                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"/></svg>
               </a>
               <span>${_t('Bastet e mia')}</span>
             </div>

            <div class="newMyBetsFilter">
              <input type="text" readonly  class="form-control" id="myCalendar">
              <button type="button" class="btn-filter">${_t('Filtro')}</button>
            </div>

            <div class="my-bets-select-filters border-top ${role === "User" ? 'hidden' : ''}">
              <select name="accountCoinSelect" id="myBetsUserDetailsUserCoinSelect" class="${role == "User" || role == "Agent" ? "hidden" : ""}" placeholder="${_t('Monedha')}">
                ${userCoinsView}
              </select>
              <select name="accountAgentSelect" id="agentSelect" class="${role == "User" ? "hidden" : ""}">
                <option value="">${_t('Zgjidh perdorues')}</option>
                ${agentsView}
              </select>
            </div>

             <div class="filterMyBetsAdmin">
                <a class="active" data-param-id="0"> ${_t('Te gjitha')} </a>
                <a class="" data-param-id=4> ${_t('Fituese')} </a>
                <a class="" data-param-id="5"> ${_t('Humbese')} </a>
                <a class="" data-param-id="2"> ${_t('Ne pritje')} </a>
                <a class="" data-param-id="6"> ${_t('Te anuluara')} </a>
             </div>
             <span id="sortByValue" sort-dir="" style="
              float: right; color: #ffffff; font-size: 14px; margin-top: 10px; margin-right: 10px; z-index: 99; position: relative;
             ">${_t('Shuma')}<i></i></span>
             <div class="myBetsTable m-t-6"  id="tblMyBets" style="margin-top: -30px">

             </div>
             <div class="myBetsFooter m-t-6">
               <span>${_t('All')}</span>
               <span></span>
               <span id="totalBetsValue"></span>
             </div>
           </div>
     `;
    return view;
  },
  after_render: async () => {
    const getCurrency = () => {
      return $('#myBetsUserDetailsUserCoinSelect option:selected').text();
    }

    $('body #predefinedRanges .my-bets-tabs__item').unbind('click');

    const start = localStorage.getItem("betsStartDate") ? moment(localStorage.getItem("betsStartDate"), 'YYYY-MM-DD').startOf('day') : moment().startOf('day');
    const end = localStorage.getItem("betsEndDate") ? moment(localStorage.getItem("betsEndDate"), 'YYYY-MM-DD').endOf('day') : moment().endOf('day');


    

    $('body').on('click', '.filterMyBetsAdmin a', async function(e){
      $(e.currentTarget).parent().children('a').removeClass('active');
      $(e.currentTarget).addClass('active');
        let filterId = $(e.currentTarget).attr('data-param-id');

        let myBets;

        let valueOfDate = $('body #myCalendar').val();

        let startDatet = (valueOfDate.split(' ')[0]).replace(/\//g, "-");
        let endDatet = (valueOfDate.split(' ')[2]).replace(/\//g, "-");

        let startDate = startDatet.split('-')[2] + '-' + startDatet.split('-')[0] + '-' + startDatet.split('-')[1];
        let endDate = endDatet.split('-')[2] + '-' + endDatet.split('-')[0] + '-' + endDatet.split('-')[1];


        console.log(startDate,endDate)

        if (agentId > 0)
          myBets = await getBetsByUserFilter(agentId, startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val(), filterId);
        else myBets = await mybets(startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val());

        let littleView = await generateView(myBets);

        $("body #tblMyBets *").remove();
        $("body #tblMyBets").append(littleView);

        let totalBet = 0;
        let winTotal = 0;
        myBets.forEach(element => {
            totalBet += parseFloat(element.stake);
            if (element.name == "Won" && element.possible_win)
              winTotal += parseFloat(element.possible_win);
        });

        $("body #totalBetsValue").text(Utils.formatNumber((totalBet - winTotal), getCurrency(), 0));
        $("body .loaderWrapper").remove();

    });


    let mybetsprofile = await getBetsByUser(agentId, start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD'),  $('#myBetsUserDetailsUserCoinSelect').val());
    let totalBet = 0;
    let winTotal = 0;
    mybetsprofile.forEach(element => {
        totalBet += parseFloat(element.stake);
        if (element.name == "Won" && element.possible_win)
          winTotal += parseFloat(element.possible_win);
    });

    $("body #totalBetsValue").text(Utils.formatNumber((totalBet - winTotal), getCurrency(), 0));
    let myBetsView = await generateView(mybetsprofile);
    $("body #tblMyBets").append(myBetsView);

    async function dateRangePickerCallback(start, end, label) {
      $("#contentLoader").append(
        '<div class="loaderWrapper">\n' +
          '            <div class="loader"></div>\n' +
          "        </div>"
      );
      console.log(
        "New date range selected: " +
          start.format("YYYY-MM-DD") +
          " to " +
          end.format("YYYY-MM-DD") +
          " (predefined range: " +
          label +
          ")"
      );
      startDate = start.format("YYYY-MM-DD");
      endDate = end.format("YYYY-MM-DD");
      let myBets;

      if (agentId > 0)
        myBets = await getBetsByUser(agentId, startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val(),0);
      else myBets = await mybets(startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val());

      if (MyBetsUserDetails.selectedUser) {
        myBets = myBets.filter(b => b.username === MyBetsUserDetails.selectedUser);
      } 
      let littleView = await generateView(myBets);

      $("body #tblMyBets *").remove();
      $("body #tblMyBets").append(littleView);

      let totalBet = 0;
      let winTotal = 0;
      myBets.forEach(element => {
          totalBet += parseFloat(element.stake);
          if (element.name == "Won" && element.possible_win)
            winTotal += parseFloat(element.possible_win);
      });

      $("body #totalBetsValue").text(Utils.formatNumber((totalBet - winTotal), getCurrency(), 0));
      $("body .loaderWrapper").remove();
      localStorage.setItem("betsStartDate", startDate);
      localStorage.setItem("betsEndDate", endDate);
    };
    $("#myCalendar").daterangepicker(
      {
        ranges: ranges,
        startDate: start,
        endDate: end,
        alwaysShowCalendars: true,
        opens: "center",
        linkedCalendars: false, // This prevents showing two months
        showCustomRangeLabel: false, 
      },
      async () => await dateRangePickerCallback(start, end)
    );



    $('.newMyBetsFilter .btn-filter').click(function(e) {
      e.preventDefault();
      $('.filterMyBetsAdmin a').removeClass('active');
      $('.filterMyBetsAdmin a:first-child').addClass('active');
      const start = $('#myCalendar').data('daterangepicker').startDate;
      const end = $('#myCalendar').data('daterangepicker').endDate;
      dateRangePickerCallback(start, end);
    });

    $('body').on('change', '#myBetsUserDetailsUserCoinSelect', async function(e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      let myBets;

      if (agentId > 0)
        myBets = await getBetsByUser(agentId, startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val());
      else myBets = await mybets(startDate, endDate,  $('#myBetsUserDetailsUserCoinSelect').val());

      let littleView = await generateView(myBets);

      $("body #tblMyBets *").remove();
      $("body #tblMyBets").append(littleView);

      let totalBet = 0;
      let winTotal = 0;
      myBets.forEach(element => {
          totalBet += parseFloat(element.stake);
          if (element.name == "Won" && element.possible_win)
            winTotal += parseFloat(element.possible_win);
      });

      $("body #totalBetsValue").text(Utils.formatNumber((totalBet - winTotal), getCurrency(), 0));
      $("body .loaderWrapper").remove();

    });

    $("body").on("click", ".singleBetHeader", async function (e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      if ($(e.currentTarget).parent().hasClass("showDetail")) {
        $(e.currentTarget).parent().removeClass("showDetail");
        $(e.currentTarget)
          .siblings(".singleBetContent")
          .children(".singleBetItem")
          .remove();
      } else {
        var getmyBets = await mybet($(this).attr("bet-id"));
        if(getmyBets.length < 3 ){
          $(e.currentTarget).parent().attr('cash-out-status', 'false');
          $(e.currentTarget).siblings('.cashoutHolderBtn').remove();
        }

        if( $(e.currentTarget).parent('.singleBetTable').attr('cashingout') === 'true' ){
          $(e.currentTarget).parent().append(`<div class="cashedOutHolder"><span>${_t('Cashed Out')}</span><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="color:#000000;enable-background:accumulate;" d="m 43,963.36219 -30,10 0,37.62501 c 0,13.46 15.9375,20.8512 30,30.375 6.452529,-4.3699 13.28977,-8.2973 18.8125,-12.5625 C 58.84116,1025.892 57,1021.8314 57,1017.3622 c 0,-8.8129 7.187129,-16 16,-16 l 0,-28.00001 -30,-10 z m 30,40.00001 c -7.73199,0 -14,6.268 -14,14 0,7.732 6.26801,14 14,14 7.731979,0 14,-6.268 14,-14 0,-7.732 -6.268021,-14 -14,-14 z m 0,5 c 1.1046,0 2,0.8954 2,2 l 0,5 5,0 c 1.104569,0 2,0.8954 2,2 0,1.1046 -0.895431,2 -2,2 l -5,0 0,5 c 0,1.1046 -0.8954,2 -2,2 -1.104601,0 -2,-0.8954 -2,-2 l 0,-5 -5,0 c -1.10457,0 -2,-0.8954 -2,-2 0,-1.1046 0.89543,-2 2,-2 l 5,0 0,-5 c 0,-1.1046 0.895399,-2 2,-2 z" fill="#000000" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"/></g></svg></div>`)
        }else {
          $(e.currentTarget).parent().children('.cashedOutHolder').remove();
        }

        getmyBets.forEach((getmyBet) => {
          let cashingOut = '';
          let cashingOutLabel = '';
          let statusBet = '';
          let typeLabel = '';
          if (getmyBet.bet_detail_status === "Lost") {
            statusBet = "lostBetItem";
          }
          if (getmyBet.bet_detail_status === "Won") {
            statusBet = "wonBetItem";
          }
          if (getmyBet.bet_detail_status === "Approved") {
            statusBet = "approvedBetItem";
          }
          if (getmyBet.bet_detail_status === "Canceled") {
            statusBet = "canceledBetItem";
          }
          if (getmyBet.type_id == 2) {
              typeLabel = '<b>Live - </b>';
              $(e.currentTarget).parent().attr('cash-out-status', 'false');
              $(e.currentTarget).siblings('.cashoutHolderBtn').remove();
          }
          if (getmyBet.game_cash_out == 1){
            cashingOutLabel = 'cashing ';
            cashingOut = `<div class="defendedGame"><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" version="1.1" x="0px" y="0px" viewBox="0 0 100 100"><g transform="translate(0,-952.36218)"><path style="color:#000000;enable-background:accumulate;" d="m 43,963.36219 -30,10 0,37.62501 c 0,13.46 15.9375,20.8512 30,30.375 6.45253,-4.3699 13.28977,-8.2973 18.8125,-12.5625 C 58.84116,1025.892 57,1021.8314 57,1017.3622 c 0,-8.8129 7.18713,-16 16,-16 l 0,-28.00001 -30,-10 z m 30,40.00001 c -7.73199,0 -14,6.268 -14,14 0,7.732 6.26801,14 14,14 7.73198,0 14,-6.268 14,-14 0,-7.732 -6.26802,-14 -14,-14 z m 0,5 c 0.57711,0 1.07243,0.2653 1.4375,0.6562 1.66486,1.4838 3.30646,3.3365 4.96875,4.9376 0.80455,0.8045 0.78114,2.0316 0,2.8124 -0.78114,0.7812 -2.03138,0.7812 -2.8125,0 L 75,1015.1747 l 0,9.1875 c 0,1.1046 -0.8953,2 -2,2 -1.1047,0 -2,-0.8954 -2,-2 l 0,-9.1875 -1.59375,1.5937 c -0.78112,0.7812 -2.03136,0.7812 -2.8125,0 -0.78114,-0.7808 -0.79674,-2.0079 0,-2.8124 1.62691,-1.637 3.33311,-3.4237 4.96875,-4.9376 0.36508,-0.3909 0.86039,-0.6562 1.4375,-0.6562 z" fill="#000000" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"/></g></svg></div>`;
          }
          $(e.currentTarget).siblings('.singleBetContent').append('<div class="singleBetItem cashoutHolder ' + cashingOutLabel + statusBet + '">\n' +
              '                       <div class="singleBetItemIcon">\n' +
              '                         <svg class="lostIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#C46464" cx="6" cy="6" r="6"></circle><path fill="#000" d="M6.414 6L8.69 3.724l-.414-.414L6 5.586 3.724 3.31l-.414.414L5.586 6 3.352 8.276l.414.414L6 6.414 8.234 8.69l.414-.414z"></path></g></svg>\n' +
              '                         <svg class="canceledIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#01979e" cx="6" cy="6" r="6"></circle><path fill="#fff" d="M6.414 6L8.69 3.724l-.414-.414L6 5.586 3.724 3.31l-.414.414L5.586 6 3.352 8.276l.414.414L6 6.414 8.234 8.69l.414-.414z"></path></g></svg>\n' +
              '                         <svg class="wonIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#4ACFA5" cx="6" cy="6" r="6"></circle><path fill="#0B1C19" d="M2.4 6.207L5.172 9.02l4.8-4.8-.579-.621-4.22 4.18L3.02 5.627z"></path></g></svg>\n' +
              '                         <svg class="approvedIcon" xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 12 12"><g fill-rule="nonzero" fill="none"><circle fill="#01979e" cx="6" cy="6" r="6"></circle><path fill="#fff" d="M2.4 6.207L5.172 9.02l4.8-4.8-.579-.621-4.22 4.18L3.02 5.627z"></path></g></svg>\n' +
              '                       </div>\n' +
              '                       <div class="singleBetItemDetails">\n' +
              '                         <span>' + typeLabel + '<i>' + getmyBet.game_date.split(" ")[0] + ' ' + (getmyBet.game_date.split(" ")[1]).split(':')[0] + ':' + (getmyBet.game_date.split(" ")[1]).split(':')[1] + '</i>' + getmyBet.home_team + '-' + getmyBet.away_team + '</span>\n' +
              '                         <span>' + _t(getmyBet.market_name) + ' - ' + _t(getmyBet.market_option_name) + '</span>\n' +
              '                       </div>\n' +
              '                       <span class="singleBetItemOdd"><span style="min-width: 20px; display: block;">' + Math.floor((parseFloat(getmyBet.coeficient_value) + Number.EPSILON) * 100) / 100 + `</span><span class="expander" game-api-id="${getmyBet.game_api_id}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" preserveAspectRatio="none"><path fill="#F8F8F8" fill-rule="evenodd" d="M6.216 12L7 11.243 1.569 6 7 .757 6.216 0 .784 5.243 0 6l.784.757z"></path></svg></span></span>\n` +
              `<div class="timeline-wrapper" style="display: block; clear: both;"></div>\n`+ cashingOut +'\n' +
              '                     </div>');
        });
        $(e.currentTarget).parent().addClass("showDetail");

        $(".singleBetItemOdd .expander").unbind('click');
        $(".singleBetItemOdd .expander").click(async function (e) {
          e.preventDefault();
          $(this).toggleClass('open');
          var $timelineWrapper = $(this).closest('.singleBetItem').find('.timeline-wrapper');
          if($(this).hasClass('open')) {
            var gameId = $(this).attr('game-api-id');
            var timeline = await Timeline.render(gameId);
            $timelineWrapper.html(timeline);
            Timeline.refreshTimeline(gameId);
          } else {
            $timelineWrapper.html('');
          }
        });
      }
    });

    
    $('body').on('change', '#agentSelect', function(e) {
      e.preventDefault()
      e.stopPropagation();
      e.stopImmediatePropagation();
      MyBetsUserDetails.selectedUser = $(e.currentTarget).val();
      $('.btn-filter').click();
      // alert($(e.currentTarget).val());
    });

    $('#sortByValue').on('click', function(e) {
      e.preventDefault();
      let dir = $(this).attr('sort-dir');
      if (!dir || dir === 'ASC') {
        dir = 'DESC';
      } else {
        dir = 'ASC';
      }

      $('.myBetGroupWrapper').each(function(item) {
        let $content = $(this).find('.myBetGroupContent');
        $content.children().sort(function (a, b) {
          var contentA =parseInt( $(a).data('value'));
          var contentB =parseInt( $(b).data('value'));
          if(dir === 'ASC') {
            return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
          }
          return (contentA > contentB) ? -1 : (contentA < contentB) ? 1 : 0;
        }).appendTo($content);
      })
      

      $(this).attr('sort-dir', dir);
      $(this).find('i').html(dir === 'ASC' ? ' &#x2193;' : ' &uarr;');
    })
  },
  hideFooterCasino: true
};

export default MyBetsUserDetails;
